/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { kRV_GetATPLeadTimeWithQuantityAsync } from '../custom-proxy/DataActionExtension.g';
import { IKRV_ATPLeadTimePropertiesQuantity, IKRV_ATPLeadTimeQuantityRequestBody } from '../custom-proxy/DataServiceEntities.g';

/**
 * CalculateEstDateAtp Input Action
 */
export class CalculateEstDateAtpInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public itemId: string;
    public quantity: number;
    constructor(itemId: string, quantity: number) {
        this.itemId = itemId;
        this.quantity = quantity;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CalculateEstDateAtp`;
    public getCacheObjectType = () => 'CalculateEstDateAtp';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface ICalculateEstDateAtpData {
    // text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
// const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
//     return new CalculateEstDateAtpInput();
// };

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function estimatedAvailabilityAction(
    input: CalculateEstDateAtpInput,
    ctx: Msdyn365.IActionContext
): Promise<IKRV_ATPLeadTimePropertiesQuantity> {
    const requestBodyEst: IKRV_ATPLeadTimeQuantityRequestBody = {
        itemId: input.itemId,
        quantity: input.quantity
    };
    const response = await kRV_GetATPLeadTimeWithQuantityAsync({ callerContext: ctx }, requestBodyEst.itemId, requestBodyEst.quantity);
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IKRV_ATPLeadTimePropertiesQuantity>>estimatedAvailabilityAction,
    // TODO: Give your data action a unique id
    id: 'CalculateEstDateAtp'
    // input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
